/**
 * DRIS Dark Mode Palette
 *
 * Dark palette designed around the DRIS green brand identity.
 * Analysis colors (sap, tissue, soil) are intentionally identical
 * to the light palette — they must remain fixed for data consistency.
 */

import { drisAnalysisColors } from './colors';

export const drisDarkPalette = {
  primary: {
    main: '#66BB6A',       // Green 400 — ~6.6:1 contrast on #121212
    light: '#81C784',      // Green 300
    dark: '#388E3C',       // Green 700
    contrastText: '#000000',
  },
  secondary: {
    main: '#7C7FE8',       // Lighter blue variant for dark surfaces
    light: '#9FA2F0',
    dark: '#5558C8',
    contrastText: '#000000',
  },
  success: {
    main: '#81C784',       // Green 300
    light: '#A5D6A7',
    dark: '#4CAF50',
    contrastText: '#000000',
  },
  warning: {
    main: '#FFD54F',       // Amber 300
    light: '#FFE082',
    dark: '#FFC107',
    contrastText: '#000000',
  },
  error: {
    main: '#EF5350',       // Red 400
    light: '#E57373',
    dark: '#D32F2F',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#64B5F6',       // Blue 300
    light: '#90CAF9',
    dark: '#42A5F5',
    contrastText: '#000000',
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  text: {
    primary: '#E0E0E0',     // 14.3:1 contrast on #121212
    secondary: '#A0A0A0',   // 7.3:1 contrast on #121212
    disabled: '#616161',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  analysis: drisAnalysisColors,
  action: {
    active: 'rgba(255, 255, 255, 0.56)',
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(255, 255, 255, 0.16)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};
